import _get from 'lodash/get';

/**
 *
 * @class VttItem
 * @desc Represents a VTT subtitle track
 * @module VttItem
 *
 */
class VttItem {

    /**
     *
     * @param {object} config Initial config object
     * @constructor
     *
     */
    constructor(config) {

        /**
         *
         * @type {string}
         * @desc is given a value indicating which language that subtitle set is for — for example
         * English or Deutsch — these labels will appear in the user interface to allow the user
         * to easily select which subtitle language they want to see
         * @default "English"
         *
         */
        this.label = _get(config, 'label', 'English');

        /**
         *
         * @type {string}
         * @desc is given a value of subtitles, indicating the type of content the files contain
         * @default "subtitles"
         *
         */
        this.kind = _get(config, 'kind', 'subtitles');

        /**
         *
         * @type {string}
         * @desc indicates what language each subtitle files' contents are in.
         *
         */
        this.srclang = _get(config, 'srclang');

        /**
         *
         * @type {string}
         * @desc is assigned a valid URL pointing to the relevant WebVTT subtitle file in each case.
         *
         */
        this.src = _get(config, 'src');

        /**
         *
         * @type {boolean}
         * @desc indicates to the browser that this is the default subtitle file definition to use
         * when subtitles have been turned on and the user has not made a specific selection.
         * @default false
         *
         */
        this.default = _get(config, 'default', false);

    }

}

export default VttItem;
